import _ from 'lodash';
import styled from 'styled-components';

// import { APP_IMG } from 'src/constants';

const CardV = ({
  link = '',
  data = {},
  showBlurb = true,
  external = false,
  externalLink
}) => {
  if (_.isEmpty(data)) return null;
  const url = external
    ? `url(${externalLink}${data.image})`
    : `url(${data.image})`;
  return (
    <>
      <CardnWrapper showBlurb={showBlurb}>
        <div className='blog-card'>
          <div className='meta'>
            <div className='photo' style={{ backgroundImage: url }} />
          </div>
        </div>
        {showBlurb && (
            <a
              href={link ? `${link}${data?.link}` : data?.link}
              target='_blank'
              rel='noopener noreferrer'
              className='content'
            >
              <div className='title text-excerpt-3'> {data.title} </div>
              <div className='see-more'> <p> อ่านต่อ </p></div>
            </a>
        )}
      </CardnWrapper>
    </>
  );
};

const CardnWrapper = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  width: 100%;
  a {
    display: block;
    text-decoration: none;
    
  }
  
  .blog-card {
    /* width: 100%;
    height:  100%; */
    border-radius: 5px;
    padding: 3px;
    background-color: rgb(181,181,181);
    background: linear-gradient(0deg, rgba(181,181,181,1) 0%, rgba(82,82,82,1) 12%, rgba(255,255,255,1) 25%, rgba(206,206,206,1) 63%, rgba(98,98,98,1) 83%, rgba(163,163,163,1) 100%); 
  
    display: flex;
    flex-direction: column;
    box-shadow: 0 3px 7px -1px rgba(#000, .1);
    line-height: 1.4;
    font-family: sans-serif;
    border-radius: 18px;
    overflow: hidden;
    z-index: 0;
    a {
      color: inherit;
      &:hover {
        color: rgba(190,0,0,1);
      }
    }
    &:hover {
      .photo {
        transform: scale(1.3) rotate(3deg);
      }
    }
    .meta {
      position: relative;
      z-index: 0;
      height: auto;
      padding-top: 56.25%;
      background:#000000;
      border-radius: 15px;
    }
    .photo {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      aspect-ratio: 16/9;
      background-size: cover;
      background-position: 50% 30%;
      transition: transform .2s;
      border-radius: 15px;
    }
  }
  .content {
    display: grid;
    grid-template-columns: 3fr 1fr;
    padding: 1rem 0;
    width: 100%;
    grid-gap: 10px;
   
    .title {
      display: block;
      font-size: 17pt;
      font-weight: 500;
      color: #ffffff;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: 2;

      &:hover {
        color:rgb(181,181,181);
      }
    }
    .see-more {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      @media (max-width: 768px) {
      width: fit-content;
      }
    }
    .see-more p {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000000;
      border-radius: 20px;
      border: 2px solid rgb(181,181,181);
      font-size: 17pt;
      height: 40px;
      color: rgb(181,181,181);
      @media (max-width: 768px) {
        font-size: 12pt;
        padding: 5px 15px;
        margin-top: 10px;
        height: 30px;
      }
    }
    &:hover {
     opacity: 0.8;
    }
  }
  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    .blog-card  {
      width: 100%;
    }
    .content {
      display: block;
      margin-left: 15px;
      padding: 0;
      .title{
        font-size: 12pt;
      }
    }
  }

  @media (max-width: 375px) {
    display: block;
    .blog-card  {
      margin-bottom: 10px;
      padding: 5px;
    }
   .content {
    margin: auto;
   }
  }
`;

export default CardV;
